<template>
  <div>
    <div v-if="!isMobile">
      <el-input
        v-model="vForm.content"
        type="textarea"
        placeholder="请输入评论内容"
        rows="3"
      />
      <div class="dialog-footer">
        <div class="user">
          <div class="label">评论用户信息：</div>
          <div class="avatar-box">
            <el-image
              class="avatar"
              fit="contain"
              :src="vForm.avatar"
            ></el-image>
            <div v-if="isEditUser" class="avatar-mask" @click="selectAvatar">
              <i class="iconfont icon-upload"></i>
            </div>
          </div>
          <div v-if="!isEditUser" class="name">{{ vForm.nickname }}</div>
          <input
            v-if="isEditUser"
            v-model="vForm.nickname"
            class="name-edit"
            type="text"
          />
          <i
            v-if="!isEditUser"
            class="iconfont icon-edit"
            @click="isEditUser = true"
          ></i>
          <div v-if="isEditUser" class="done" @click="saveUser">保存</div>
          <input ref="imageInput" hidden type="file" accept="image/*" />
        </div>
        <div class="btns">
          <el-button
            type="primary"
            :loading="doSubmitLoading"
            size="small"
            @click="doSubmit"
            >发表评论</el-button
          >
        </div>
      </div>
    </div>
    <div v-if="isMobile" class="drawer-footer">
      <div class="input-placeholder" @click="isShowMobileCommit = true">
        请输入评论内容
      </div>
      <div class="user" @click="isShowEditUser = true">
        <div class="avatar-box">
          <el-image class="avatar" fit="contain" :src="user.avatar"></el-image>
        </div>
        <div class="name"><div class="v-ellipsis">{{ user.nickname }}</div></div>
        <i class="iconfont icon-edit"></i>
        <input ref="imageInput" hidden type="file" accept="image/*" />
      </div>
    </div>
    <van-dialog
      v-model="isShowMobileCommit"
      title="评论"
      show-cancel-button
      :beforeClose="doSubmit"
    >
      <div class="mobile-commit">
        <el-input
          v-model="vForm.content"
          type="textarea"
          placeholder="请输入评论内容"
          rows="4"
          autofocus
        ></el-input>
      </div>
    </van-dialog>
    <van-dialog
      v-model="isShowEditUser"
      title="修改用户信息"
      show-cancel-button
      @confirm="saveUser"
      @cancel="cancelSaveUser"
    >
      <div class="mobile-user-edit">
        <div class="avatar-box">
          <el-image class="avatar" fit="contain" :src="vForm.avatar"></el-image>
          <div class="avatar-mask" @click="selectAvatar">
            <i class="iconfont icon-upload"></i>
          </div>
        </div>
        <el-input  v-model="vForm.nickname"></el-input>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog, Toast } from "vant";
Vue.use(Dialog);
export default {
  data() {
    return {
      doSubmitLoading: false,
      isEditUser: false,
      isShowEdit: false,
      worksId: this.$route.query.id,
      user: JSON.parse(localStorage.getItem("v-comment-user")),
      vForm: {
        worksId: this.$route.query.id,
        id: "",
        lid: "",
        avatar: "",
        nickname: "",
        content: "",
      },
      isShowMobileCommit: false,
      isShowEditUser: false,
    };
  },
  created() {
    Object.assign(this.vForm, this.user);
  },
  methods: {
    saveUser(e) {
      let { lid, nickname, avatar } = this.vForm;
      localStorage.setItem(
        "v-comment-user",
        JSON.stringify({ lid, nickname, avatar })
      );
      this.user = { lid, nickname, avatar};
      this.isEditUser = false;
    },

    cancelSaveUser(){
       Object.assign(this.vForm, this.user)
    },

    selectAvatar() {
      let input = this.$refs.imageInput;
      input.click();
      input.onchange = (e) => {
        let files = e.target.files;
        this.doUpload(files);
      };
    },

    //上传文件
    async doUpload(files) {
      this.loading = true;
      try {
        let res = await this.utils.upload.uploadFiles(files);
        this.vForm.avatar = res[0].preview;
      } catch (e) {
        console.error(e);
      }
      this.$refs.imageInput.value = "";
      this.loading = false;
    },

    async doSubmit(e, done = Function) {
      if (e == "cancel") {
        done();
        return;
      }
      if (this.vForm.nickname.trim().length == 0) {
        this.isMobile
          ? Toast("用户名称不能为空")
          : this.$message.error("用户名称不能为空");
        return;
      }
      if (this.vForm.content.trim().length == 0) {
        this.isMobile
          ? Toast("评论内容不能为空")
          : this.$message.error("评论内容不能为空");
        done(false);
        return;
      }
      this.doSubmitLoading = true;
      try {
        this.saveUser();
        await this.api.comment.create(this.vForm);
        this.vForm.content = "";
        this.isMobile
          ? Toast({ message: "评论成功", position: "bottom" })
          : this.$message.success("评论成功");
        this.$store.dispatch("preview/getCommentList", {
          worksId: this.worksId,
        });
        done();
      } catch (e) {
        console.log(e);
      }
      this.doSubmitLoading = false;
      done(false);
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  margin-top: 20px;
}
.dialog-footer .user {
  display: flex;
  align-items: center;
}
.dialog-footer .avatar-box {
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  overflow: hidden;
  margin-left: 10px;
  background: #ddd;
  border: 1px solid #ddd;
}
.dialog-footer .avatar {
  width: 100%;
  height: 100%;
  display: block;
}
.dialog-footer .avatar-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dialog-footer .avatar-mask .iconfont {
  color: #fff;
  font-size: 12px;
}
.dialog-footer .name {
  font-size: 12px;
  margin: 0 5px;
  width: 100px;
  height: 20px;
  display: flex;
  align-items: center;
}
.dialog-footer .name-edit {
  width: 100px;
  height: 20px;
  border: 1px solid #ccc;
  margin: 0 5px;
  font-size: 12px;
}
.dialog-footer .icon-edit {
  font-size: 12px;
  color: #999;
  cursor: pointer;
}

.dialog-footer .done {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}

.drawer-footer {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  color: #000;
  font-size: 12px;
  padding: 10px 20px;
  border-top: 1px solid #eee;
  box-sizing: border-box;
}
.drawer-footer .input-placeholder {
  flex: 1;
  height: 24px;
  background: #eee;
  border: 1px solid #ddd;
  color: #999;
  font-size: 12px;
  padding: 0 10px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  flex: 1;
}
.drawer-footer .user {
  display: flex;
  align-items: center;
}
.drawer-footer .avatar-box {
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  overflow: hidden;
  background: #ddd;
  border: 1px solid #ddd;
}
.drawer-footer .avatar {
  width: 100%;
  height: 100%;
  display: block;
}
.drawer-footer .avatar-mask .iconfont {
  color: #fff;
  font-size: 12px;
}
.drawer-footer .name {
  font-size: 12px;
  margin: 0 5px;
  height: 20px;
  display: flex;
  align-items: center;
  max-width: 70px;
}
.drawer-footer .icon-edit {
  font-size: 12px;
  color: #999;
  cursor: pointer;
}
.mobile-commit {
  padding: 20px;
}
.mobile-user-edit{
  padding: 20px;
}
.mobile-user-edit .avatar-box{
  position: relative;
  width: 100px;
  height:100px;
   border-radius: 100%;
  overflow: hidden;
  background: #ddd;
  border: 1px solid #ddd;
  margin: 0 auto;
  margin-bottom: 20px;
}
.mobile-user-edit .avatar{
  display: block;
  width: 100%;
  height: 100%;
}
.mobile-user-edit .avatar-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 110%;
  height: 110%;
  left:50%;
  top:50%;
  transform: translate(-50%,-50%);
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.mobile-user-edit .avatar-mask .iconfont {
  color: #fff;
  font-size: 32px;
  opacity: 0.7;
}
</style>
